import AceEditor from "react-ace";
import 'ace-builds/src-noconflict/mode-text';

import { useState, useEffect } from "react";
import { EDITOR_VIEW_NAME, SOLUTION_AREA_STATE } from "../core/constants";
import { translate } from "../core/i18n";
import { store } from "../core/state";

import Draggable from 'react-draggable';
import { RoundButton } from "./buttons/base/RoundButton";
import { CloseButton } from "./buttons/base/CloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getComponentData, setComponentData } from "../core/views";

export const solutionAreaShown = (editorState) => {
  const hasSolutionContent = (editorState.data?.projectContent?.solutionCode !== undefined);
  return editorState.cfg?.editorFeatures?.solutionActive && hasSolutionContent;  
}

export const needsSolutionAfterErrors = (editorState) => {
  if (editorState?.cfg.editorFeatures.showSolutionAfterErrors > 0) {
    if (editorState?.data?.errorCounter === undefined || editorState?.data?.errorCounter < editorState?.cfg.editorFeatures.showSolutionAfterErrors) return false;
  }
  return true;
}

export const triggerShowSolutionArea = () => {
  const solutionAreaState = getComponentData(SOLUTION_AREA_STATE);
  const newSolutionAreaState = { ...solutionAreaState, show: true };
  setComponentData(SOLUTION_AREA_STATE, newSolutionAreaState);
}

export const SolutionArea = (props) => {
  const [showSolutionState, setShowSolutionState] = useState(false);
  const [solutionAreaState] = store.useState(SOLUTION_AREA_STATE);
  const [editorState] = store.useState(EDITOR_VIEW_NAME);

  useEffect(() => {    
    if (solutionAreaState.show) {
      setShowSolutionState(true);
    }
  }, [solutionAreaState]);

  if (!editorState?.project?.solution || !editorState?.data?.projectContent.solutionCode) return null;
  if (!needsSolutionAfterErrors(editorState)) return null;

  const openArea = () => {
    setShowSolutionState(true);
  }

  const closeArea = () => {
    setShowSolutionState(false);
  }

  const options = {
    readOnly: true,
    fontSize: "15px",
    theme: "ace/theme/clouds"
  }

  const solutionCode = editorState?.data?.projectContent.solutionCode;

  const openButton = <RoundButton icon="key" className="m-1" onClick={openArea} title={translate('view-editor-solution-button')} />
  const infoCard = (
    <Draggable handle=".draggable-header">
      <div className="draggableArea card card-design">
        <div className="card-header draggable-header">
          <div className="row">
          <div className="col-6"><FontAwesomeIcon icon="key" /> {translate('view-editor-solution-button')}</div>
            <div className="text-end col-6">
              <CloseButton onClick={closeArea} />
            </div>
          </div>
        </div>        
            <AceEditor className="card-body"
              mode={"text"}
              name="solution"                            
              value={solutionCode}
              setOptions={options}
              width={props.width}
            />            
      </div>
    </Draggable>
  );

  return (	
    <span>
      { !showSolutionState && openButton }
      { showSolutionState && infoCard }
    </span>
  );
}